/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import AtmBulkImport from "./atmBulkImport";

/* Styles */
import styles from "./styles";


const LoyaltyAtmBulkImportModal = ({showAtmBulkImportModal, setShowAtmBulkImportModal, allotmentId, setAssignModalShow, onRedeemCompleted }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const [isUploading, setIsUploading] = useState(false);

  const handleSaveModal = () => {
    setShowAtmBulkImportModal(false)
  }

  return (
    <UCModal
      mainModalDivStyling={classes.mainModalDiv}
      className={ `${classes.modal} ${isUploading ? classes.disableClose : ""}` }
      showModal={ showAtmBulkImportModal }
      setShowModal={ setShowAtmBulkImportModal }
      modalHeaderTitle={
        <FormattedMessage id="loyalty.atmBulkImport.modalTitle"/>
      }
      modalDescription={
        <p className={classes.description}>
          <FormattedMessage id="loyalty.atmBulkImport.modalDescription" />
        </p>
      }
      modalContent={
        <>
          <div className={classes.dropzone}>
            <AtmBulkImport
              setShowAtmBulkImportModal={setShowAtmBulkImportModal}
              isUploading={isUploading} setIsUploading={setIsUploading}
              allotmentId={allotmentId}
              onRedeemCompleted={onRedeemCompleted}
              setAssignModalShow={setAssignModalShow}
            />
          </div>
        </>
      }
    />
  )
}

export default LoyaltyAtmBulkImportModal;
